
<div class="background">
  <div class="back-btn" (click)="close()"></div>
  <div class="more-like-this focusable-container horizontal-focusable-container" data-blocked *ngIf="recommendationsContainerVM">
      <app-cards-carousel
        *ngIf="recommendationsContainerVM?.resources?.length > 0"
        #cardList
        [className]="'more-like-this-carousel'"
        [container]="recommendationsContainerVM"
        [carouselType]="getCarouselType(recommendationsContainerVM)"
        [showPlayIcon]="getShowPlayIcon(recommendationsContainerVM)"
        (cardWithFocus)="focusChanged()"
        [navigateToPlayer]="true"
        [isPlayerCarousel]="true"
        (clickAction)="close()"
      ></app-cards-carousel>
  </div>
</div>
